import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Division, Language } from '../../shared/model';

import { SharedService } from '../../shared/shared.service';
import { DisclaimerService } from '../../disclaimer/disclaimer.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-topbar',
    templateUrl: 'topbar.component.html',
    styleUrls: ['./topbar.component.css']
})

export class TopbarComponent implements OnInit {
    @Input() userName: string;
    @Input() userInitials: string;
    @Input() division: Division;
    @Input() languages: Language = <Language>{};
    @Input() selectedLanguage: Language = <Language>{};

    constructor(private sharedService: SharedService,
        private disclaimerService: DisclaimerService,
        private router: Router) {
    }

    ngOnInit() { }

    languageChange(event) {
        this.sharedService.setLanguageIndicator()
        .pipe(finalize(() => {
            const selectedLanguage: Language = <Language>{
                Id: event.Id,
                Name: event.Name,
                LanguageCode: event.LanguageCode
            };

            this.sharedService.setCurrentLanguage(selectedLanguage);
            window.location.reload();
        }))
        .subscribe();
    }

    showPrivacyNotice() {
        this.disclaimerService.ShowPrivacyNotice();
    }

    pageReload(event: any) {
        if ( this.router.url === '/main') {
            window.location.reload();
        }
    }

    getFlagSrc(languageCode: any): string {
        if (languageCode) {
            const code = languageCode.toString().toUpperCase();
            return '../../../assets/GDPR/' + code + '.svg';
        }

        return '../../../assets/GDPR/EN.svg';
    }

    shouldShowThermalHeader(): boolean {
        return this.division == Division.ThermalEurope;
    }

    getRouterLinkForBrand(): string {
        return this.division != Division.ConditionsNotFulfilled ? "/main" : "/no-division-page";
    }
}
